import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceintalawadepune() {



const cardData = {
  keyword: " Cab Service in Talawade Pune ",

"headingDescription": "SRS Cab Service offers Cab Service in Talawade Pune, providing reliable, efficient, and comfortable travel solutions for professionals, residents, and industrial workers. Whether you require daily commuting, IT park travel, airport transfers, or outstation cab services, our well-maintained vehicles and experienced drivers ensure a smooth and safe journey. With quick booking options, transparent pricing, and 24/7 customer support, SRS Cab Service makes travel in Talawade convenient, timely, and completely hassle-free.",
"topPlaces": [
  {
    "title": "Talawade IT Park",
    "description": "Talawade IT Park is a major hub for IT companies and professionals. Travelers using Cab Service in Talawade Pune from SRS Cab Service frequently commute here for office work and meetings."
  },
  {
    "title": "Chakan MIDC",
    "description": "Chakan MIDC is a large industrial area near Talawade, attracting business travelers and workers. Visitors using SRS Cab Service often travel here for corporate and industrial visits."
  },
  {
    "title": "Spine Road",
    "description": "Spine Road is a key connectivity route in the PCMC area, linking Talawade with nearby localities. Travelers using SRS Cab Service often use this route for smooth and quick travel."
  },
  {
    "title": "Akkalkot Swami Samarth Mandir",
    "description": "This spiritual destination near Talawade is visited by devotees for peace and blessings. Travelers using SRS Cab Service often include it in their visits."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "An educational and recreational attraction for families and children. Visitors using SRS Cab Service often visit for interactive learning experiences."
  },
  {
    "title": "Appu Ghar Amusement Park",
    "description": "Appu Ghar is a popular entertainment park offering rides and activities for all age groups. Travelers using SRS Cab Service often visit for family outings."
  },
  {
    "title": "PCMC Stadium",
    "description": "PCMC Stadium hosts sports events and fitness activities. Visitors using SRS Cab Service often travel here for matches and recreation."
  },
  {
    "title": "Durga Tekdi",
    "description": "Durga Tekdi is a scenic hill known for greenery and peaceful surroundings. Travelers using SRS Cab Service often visit for relaxation and nature walks."
  },
  {
    "title": "Kasarwadi Market",
    "description": "Kasarwadi Market is a busy shopping hub with local stores and eateries. Visitors using SRS Cab Service often explore it for shopping and food."
  },
  {
    "title": "Chinchwad Ganpati Temple",
    "description": "Chinchwad Ganpati Temple is a well-known religious site attracting devotees. Travelers using SRS Cab Service often visit to seek blessings."
  }
],



services: [
{
name: "Talawade Cab Service",
description: "Talawade cab service offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Talawade Pune",
description: "Taxi service in Talawade Pune provides convenient travel for local and intercity routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Talawade Taxi Service",
description: "Talawade taxi service offers dependable transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Talawade Pune",
description: "Cab booking Talawade Pune provides quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Talawade Pune",
description: "Taxi booking Talawade Pune offers convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Talawade Pune",
description: "Cab near Talawade Pune helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Talawade Pune",
description: "Taxi near Talawade Pune offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Talawade Pune",
description: "Best cab service in Talawade Pune provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Talawade",
description: "Cheap cab service Talawade offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Talawade",
description: "Affordable cab service Talawade provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Talawade Cab for Airport",
description: "Talawade cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Talawade Airport Cab Service",
description: "Talawade airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Talawade Cab for Outstation",
description: "Talawade cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Talawade Pune",
description: "Cab service Talawade Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Talawade Pune",
description: "Taxi service Talawade Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Talawade",
description: "Cab booking Talawade provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab on Rent in Talawade",
description: "Innova cab on rent in Talawade offers spacious SUV travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab on Rent in Talawade",
description: "Innova Crysta cab on rent in Talawade provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab on Rent in Talawade",
description: "Ertiga cab on rent in Talawade offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab on Rent in Talawade",
description: "Dzire cab on rent in Talawade provides affordable sedan travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab on Rent in Talawade",
description: "Sedan cab on rent in Talawade offers budget-friendly travel for daily and outstation journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
}
],

tableData: [
["Talawade Cab Service","Taxi Service in Talawade Pune"],
["Talawade Taxi Service","Cab Booking Talawade Pune"],
["Taxi Booking Talawade Pune","Cab Near Talawade Pune"],
["Taxi Near Talawade Pune","Best Cab Service in Talawade Pune"],
["Cheap Cab Service Talawade","Affordable Cab Service Talawade"],
["Talawade Cab for Airport","Talawade Airport Cab Service"],
["Talawade Cab for Outstation","Cab Service Talawade Pune"],
["Taxi Service Talawade Pune","Cab Booking Talawade"],
["Innova Cab on Rent in Talawade","Innova Crysta Cab on Rent in Talawade"],
["Ertiga Cab on Rent in Talawade","Dzire Cab on Rent in Talawade"],
["Sedan Cab on Rent in Talawade","Talawade Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Talawade Pune",
    WhyChoosedescription: "SRS Cab Service offers dependable cab service in Talawade Pune for daily travel, office commutes, airport transfers, and outstation trips with professional drivers and easy booking."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly cab service in Talawade with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab & Taxi Availability",
    WhyChoosedescription: "Our Talawade cab service operates 24/7, making it convenient for early morning rides, late-night pickups, shift travel, and emergency bookings."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from sedan cars like Dzire, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles for all travel needs."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are clean, air-conditioned, and regularly serviced to ensure maximum comfort and safety during your journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Talawade Area",
    WhyChoosedescription: "We provide quick pickup from homes, societies, offices, MIDC areas, and nearby locations like Chikhali, Bhosari, Nigdi, and Ravet."
  },
  {
    WhyChooseheading: "Best for Airport & Outstation Travel",
    WhyChoosedescription: "Our Talawade cab service is ideal for Pune Airport transfers, Mumbai travel, family trips, and long-distance outstation journeys."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Talawade Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by residents and professionals for punctual service, professional drivers, and reliable travel experience across Pune."
  }
]
}

const faqData = [
  { 
    question: "Do you provide cab service in Talawade Pune?", 
    answer: "Yes, SRS Cab Service offers reliable cab service in Talawade Pune for local travel, airport transfers, and outstation trips. Our service is suitable for individuals, families, and corporate bookings." 
  },
  { 
    question: "Is cab service available 24 hours in Talawade?", 
    answer: "Yes, our cab service in Talawade operates 24/7. You can book a cab anytime for early morning airport rides, late-night travel, or emergency trips." 
  },
  { 
    question: "Do you provide airport cab service from Talawade?", 
    answer: "Yes, we provide Pune Airport pickup and drop services from Talawade with on-time pickups and professional drivers for a stress-free experience." 
  },
  { 
    question: "Which areas do you cover near Talawade?", 
    answer: "We cover Chikhali, Bhosari, Nigdi, Ravet, Moshi, and nearby PCMC areas. Our cab service is available across Pune and surrounding regions." 
  },
  { 
    question: "Which vehicles are available in Talawade cab service?", 
    answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles for different travel requirements." 
  },
  { 
    question: "Can I book cab online in Talawade Pune?", 
    answer: "Yes, you can easily book cab service in Talawade Pune online or via phone with quick confirmation and easy booking process." 
  },
  { 
    question: "Do you provide outstation cab service from Talawade?", 
    answer: "Yes, we provide outstation cab services from Talawade to destinations like Mumbai, Nashik, Shirdi, Goa, and many more." 
  },
  { 
    question: "Is cab service suitable for industrial and office travel?", 
    answer: "Yes, our cab service is widely used for industrial staff transport, office commutes, and corporate travel in Talawade MIDC area." 
  },
  { 
    question: "Are cab fares affordable in Talawade?", 
    answer: "Yes, we offer affordable cab service in Talawade with transparent pricing and no hidden charges." 
  },
  { 
    question: "Are vehicles clean and drivers professional?", 
    answer: "Yes, all vehicles are regularly cleaned and sanitized, and our drivers are trained, experienced, and verified for safe travel." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Patil",
    feedback:
      "Booked cab from Talawade to Pune Airport. The driver was punctual and the car was clean and comfortable. Overall, a smooth and reliable experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Talawade Pune. I booked for Mumbai travel and the journey was very comfortable. Driver was polite and pricing was reasonable.",
    rating: 5
  }
];




















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Talawade Pune Cab Service",
  "description": "Reliable cab service in Talawade, Pune with SRS Cab. Book taxis for local travel, airport transfers, and outstation trips. 24/7 service with Innova, Ertiga, sedan, SUV, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Talawade",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "412114",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.6780",
    "longitude": "73.7670"
  },
  "url": "https://www.srscabservice.com/talawade-pune-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Talawade, Pune"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Cab Service in Talawade Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Talawade, Pune with SRS Cab. Local rides, airport transfers, and outstation trips available 24/7. Innova, Ertiga, sedan, SUV, and tempo traveller options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceintalawadepune;